<template>
<div>
    
    <v-container class="pt-16">
        <img class="mb-10 img-fluid" src="../assets/img/banner_team.jpg">
        <h2>Sobre el equipo Kefuri</h2>
        <p>Kefuri nace en colaboración de las <a target="_blank" href="https://ingenieria.uchile.cl/">Facultades de Ciencias Físicas y Matemáticas</a>, y de <a target="_blank" href="https://medicina.uchile.cl/">Medicina</a> de la <a target="_blank" href="https://uchile.cl/">Universidad de Chile</a>, a través del <a target="_blank" href="https://wic.uchile.cl/">Web Intelligence Centre</a> en el <a target="_blank" href="https://www.dii.uchile.cl/">Departamento de Ingeniería Industrial </a>, y el CICA Oriente del <a target="_blank" href="https://medicina.uchile.cl/facultad/campus-y-departamentos/campus-oriente/medicina-interna-oriente">Departamento de Medicina Oriente</a>, respectivamente.</p>
        <p>El proyecto Kefuri cuenta con la participación de un equipo multidisciplinario el cual está constantemente investigando para entender las causas de los problemas que nos llevan a tener escasez de donantes, con el fin de implementar mejoras en el sistema de procuramiento de órganos y apuntar a tener los mejores resultados.</p>
        <v-row class="pt-10">
            <v-col cols="12" sm="6" md="3">
                <v-card class="text-center card-team">
                    <v-row>
                        <v-col>
                            <v-avatar size="120px" class="mx-auto">
                                <img src="../assets/img/team/fernando.png">
                            </v-avatar> 
                        </v-col>
                    </v-row>
                    <v-card-title class="d-block">
                    Dr. Fernando González
                    </v-card-title>

                    <v-card-subtitle>
                    Médico Internista Nefrólogo MBA
                    </v-card-subtitle>
                </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="3">
                <v-card class="text-center card-team">
                    <v-row>
                        <v-col>
                            <v-avatar size="120px" class="mx-auto">
                                <img src="../assets/img/team/fran.png">
                            </v-avatar> 
                        </v-col>
                    </v-row>
                    <v-card-title class="d-block">
                    Francisca González
                    </v-card-title>

                    <v-card-subtitle>
                    <p>Ingeniera Civil Industrial</p>
                    <p>Master in Public Health Univeristy of Washington </p>
                    </v-card-subtitle>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-card class="text-center card-team">
                    <v-row>
                        <v-col>
                            <v-avatar size="120px" class="mx-auto">
                                <img src="../assets/img/team/rosa.png">
                            </v-avatar> 
                        </v-col>
                    </v-row>
                    <v-card-title class="d-block">
                    Dra. EU. Rosa Alcayaga
                    </v-card-title>

                    <v-card-subtitle>
                    Enfermera PhD en Enfermería

                    </v-card-subtitle>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-card class="text-center card-team">
                    <v-row>
                        <v-col>
                            <v-avatar size="120px" class="mx-auto">
                                <img src="../assets/img/team/felipe.png">
                            </v-avatar> 
                        </v-col>
                    </v-row>
                    <v-card-title class="d-block">
                    Felipe Vera
                    </v-card-title>

                    <v-card-subtitle>
                    Ingeniero Civil Industrial
                    Master in Business Engineering
                    </v-card-subtitle>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-card class="text-center card-team">
                    <v-row>
                        <v-col>
                            <v-avatar size="120px" class="mx-auto">
                                <img src="../assets/img/team/juan.png">
                            </v-avatar> 
                        </v-col>
                    </v-row>
                    <v-card-title class="d-block">
                    Juan D. Velásquez
                    </v-card-title>

                    <v-card-subtitle>
                    Ingeniero Eléctrico PhD Information Engineering


                    </v-card-subtitle>
                </v-card>
            </v-col>

         
        </v-row>
        
        <v-row class="py-16">
            <v-col class="flex-sm-row">
                <h3>Nuestros pilares son:</h3>
                <v-row class="pt-10 ">
                    <v-col  cols="12" sm="6" md="6">
                        <v-row>
                            <v-col cols="3">
                                <v-avatar size="90">
                                    <img src="../assets/img/team_icon/colaboracion.png">
                                </v-avatar>
                            </v-col>
                            <v-col cols="9">
                                <div class="display-1 text-red">Apoyar</div>
                                <p>Apoyar el fácil y rápido aviso de posibles donantes de órganos, con el fin de aumentar la cantidad de pacientes que ingresan a seguimiento de procuramiento y, con ello, apoyar en el aumento de la donación de órganos.</p>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                        <v-row>
                            <v-col cols="3">
                                <v-avatar size="90">
                                    <img src="../assets/img/team_icon/capacitacion.png">
                                </v-avatar>
                            </v-col>
                            <v-col cols="9">
                                <div class="display-1 text-red">Innovar</div>
                                <p>Innovar constantemente en el desarrollo de nuestro servicio para que siempre esté a la vanguardia y sea fácil de usar, esto mediante la constante investigación de procesos, datos y tecnologías de punta.</p>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                        <v-row>
                            <v-col cols="3">
                                <v-avatar size="90">
                                    <img src="../assets/img/team_icon/comunicacion.png">
                                </v-avatar>
                            </v-col>
                            <v-col cols="9">
                                <div class="display-1 text-red">Informar</div>
                                <p>Informar del estado de los pacientes notificados y con ello involucrar al personal que avisa en el desenlace del paciente. Informar de cifras de donación y trasplante y del desempeño de la institución en la cual el usuario está inserto.</p>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                        <v-row>
                            <v-col cols="3">
                                <v-avatar size="90">
                                    <img src="../assets/img/team_icon/informacion.png">
                                </v-avatar>
                            </v-col>
                            <v-col cols="9">
                                <div class="display-1 text-red">Capacitar</div>
                                <p>Capacitar a todos y cada uno de los usuarios de nuestra aplicación, enseñándoles a crear su usuario, utilizarla y enseñar de donación, procuramiento, trasplante de órganos y sus procesos</p>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
       
        <!--Hospitales adheridos-->
        <v-container class="py-16">
            <v-col>
                <h3>Hospitales Adheridos</h3>
                <p>Ya son 6 hospitales que son parte de la familia Kefuri, quienes de manera gratuita accedieron a la habilitación, mantención y seguimiento continuo de nuestro servicio.</p>
                <v-row class="pt-16">
                        <v-col class="d-flex flex-wrap bg-surface-variant">
                            <v-card
                                v-for="(item, i) in items"
                                :key="i"
                                class="mb-3 mr-3"
                                max-width="344"
                                outlined
                            >
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <div class="text-overline mb-1">
                                    {{item.text}}
                                    </div>
                                    <v-list-item-title class="text-h5">
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Se unió en: {{item.fecha}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-avatar 
                                    tile
                                    size="80"
                                >
                                    <img :src="item.src" alt="Hospital">
                                </v-list-item-avatar>
                            </v-list-item>

                            <v-card-actions class="mb-3">
                                <v-btn
                                    outlined
                                    rounded
                                    text
                                    :href="item.url"
                                    target="_blank"
                                >
                                    Visitar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-container>
        <!--Financiamiento-->
        <v-container class="py-16 ">
            <v-col>
                <h3>Financiamiento</h3>
                <p>Somos un proyecto universitario sin fines de lucro que ha sido capaz de habilitar el servicio en los hospitales adheridos gracias a fondos concursables públicos y grants de la industria. Agradecemos a quienes han hecho que 6 hospitales accedan a esta tecnología de manera gratuita, y que nuestro equipo pueda seguir investigando:</p>
                <v-row class="pt-10">
                    <v-col 
                        cols="12"
                        md="3"
                        v-for="(entidad, l) in financiamiento"
                        :key="l"
                    >
                        <v-card
                            class="mb-3 mr-4"
                            elevation="0"
                        >

                            <v-row>
                                <v-col cols="12">
                                    <div class="mb-1">
                                    {{entidad.text}}
                                    </div>
                                </v-col>
                                <v-col cols="8">
                                    <a :href="entidad.url"
                                        target="_blank"
                                    >
                                        <img class="img-fluid" :src="entidad.src" alt="Hospital">
                                    </a>
                                    
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-container>
        
    </v-container>
    </div>    
</template>

<script>
export default {
    name: 'Nosotros',
    components: {
    },

    data(){
        return{
            items: [
                { text: 'Hospital Del Salvador', fecha: 'Mayo 2019', src: require ('../assets/support/salvador.png'), url: 'https://www.hsalvador.cl/' },
                { text: 'Hospital Dr. Luis Tisné', fecha: 'Diciembre 2020', src: require ('../assets/support/hso.gif'), url: 'https://www.hsoriente.cl/' },
                { text: 'Hospital Dr. Gustavo Fricke', fecha: 'Diciembre 2021', src: require ('../assets/support/fricke.png'), url: 'http://www.hospitalfricke.cl/' },
                { text: 'Hospital San Camilo', fecha: 'Marzo 2022', src: require ('../assets/support/sancamilo.png'), url: 'https://hospitalsancamilo.cl/' },
                { text: 'Complejo Hospitalario San José', fecha: 'Abril 2022', src: require ('../assets/support/sanjose.png'), url: 'https://complejohospitalariosanjose.cl/' },
                { text: 'Hospital San Pablo', fecha: 'Agosto 2022', src: require ('../assets/support/sanpablo.jpg'), url: 'https://www.hospitalcoquimbo.cl/' },
            ],

            financiamiento: [
                { text: 'CORFO', src: require ('../assets/support/corfo.png'), url: 'https://www.corfo.cl//' },
                { text: 'Laboratorio Pfizer', src: require ('../assets/support/pfizer.png'), url: 'https://www.pfizer.cl/' },
                { text: 'Laboratorio Novartis', src: require ('../assets/support/novartis.png'), url: 'https://www.novartis.com/'},
                { text: 'ANID', src: require ('../assets/support/anid.png'), url: 'https://www.anid.cl/' },
                { text: 'Laboratorio Chile-Teva', src: require ('../assets/support/labchile-teva.png'), url: 'https://www.laboratoriochile.cl/' },
            ],
        }
    },

    
    
}
</script>

<style scoped lang="sass">

    .card-team 
        min-height: 290px

    .display-type
        display: contents

</style>